import React from 'react';
import { CheckCircle } from 'lucide-react';
const CART_URL = 'https://www.tusoluciondigital.shop/cart/43130152714306:1';
export function PricingSection() {
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-139">
          ⏰ Oferta por tiempo limitado
        </h2>

        <div className="bg-purple-900 text-white rounded-2xl p-8 md:p-12 shadow-2xl mb-8" data-id="element-140">
          <div className="space-y-4 mb-8" data-id="element-141">
            {['EBOOK Principal: "HICE ESTO PARA DEJAR DE PENSAR EN EL EN 7 DIAS"', 'EBOOK DE REGALO1: Protocolo ANTI-RECAIDA', 'EBOOK DE REGALO2: De Migajas al Amor Propio', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-142">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-143" />
                <span className="text-lg font-semibold" data-id="element-144">{item}</span>
              </div>)}
          </div>

          <div className="text-center border-t-2 border-white/30 pt-8" data-id="element-145">
            <p className="text-2xl line-through text-white/70 mb-2" data-id="element-146">
              💰$49.999
            </p>
            <p className="text-6xl md:text-7xl font-black text-yellow-300 mb-8" data-id="element-147">
              🔥 HOY SOLO: $19.999
            </p>

            <a href={CART_URL} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-xl md:text-2xl px-10 md:px-16 py-5 md:py-6 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 uppercase" data-id="element-148">
              👉 QUIERO SOLTARLO Y VOLVER A ELEGIRME HOY
            </a>
          </div>
        </div>

        <div className="bg-green-50 border-2 border-green-300 rounded-lg p-6 text-center" data-id="element-149">
          <p className="text-xl font-black text-green-800" data-id="element-150">
            🔒 Garantía sin riesgo
          </p>
          <p className="text-gray-700 mt-2" data-id="element-151">
            Garantía de satisfacción de 7 días
          </p>
        </div>
      </div>
    </section>;
}